import { render, staticRenderFns } from "./TripTypeIcon.vue?vue&type=template&id=05743731&scoped=true"
var script = {}
import style0 from "./TripTypeIcon.vue?vue&type=style&index=0&id=05743731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05743731",
  null
  
)

export default component.exports